const defaultDashboardState = {
  accountListData: null,
  popularCardListData: null,
  cardsListAllItems: 0,
  consolidatedTransactionListData: null,
  popularCards: {},
  loadingState: {
    isLoadingAccounts: false,
    isLoadingPopularCardListData: false,
    isLoadingCardListAllData: false,
    isLoadingConsolidatedTransactionList: false,
  },
  errorState: {
    accountsDataError: undefined,
    popularCardListDataError: undefined,
    cardListAllDataError: undefined,
    consolidatedTransactionListError: undefined,
  },
};

export { defaultDashboardState };
